import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';
import { InputMask } from '@react-input/mask';
import { useTranslation } from 'react-i18next';

import Days from './Days.jsx';
import DatePicker from '../DatePicker';
import TimeFilter from './TimeFilter.jsx';
import defaultAttrs from '../../lib/utils/defaultAttrs';

const Wrapper = styled.div`
  text-align: left;
  width: 100%;
`;

const DatePickerWrapper = styled.div.attrs(
  defaultAttrs({
    size: 1,
  }),
)`
  padding: 0 16px;
  margin: ${props => (props.toggleCalendar ? ' 0 0 20px' : '0')};
`;

const DateInputsAndDays = styled.div`
  background-color: ${themeGet('colors.black.5')};
  padding-bottom: 8px;
`;

const DateInputs = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const InputWrapper = styled.div`
  border-radius: 8px;
  border: 1px solid ${themeGet('colors.black.20')};
  padding: 7px 8px;
  margin: 12px 11px 24px;
  width: 45%;
  background-color: ${themeGet('colors.white')};
`;

const Input = styled.input`
  font-weight: 500 !important;
  font-size: 14px !important;
  border: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  line-height: 18px;
`;

const DATE_MASK_REPLACEMENT = { _: /\d/ };

const DateInput = ({
  activeFilter,
  startInputValue,
  endInputValue,
  dates,
  onDateChange,
  onInputChange,
  onFilterChange,
  toggleCalendar = false,
  size = 1,
  minDate,
  maxDate,
}) => {
  const { t } = useTranslation('shared');
  return (
    <Wrapper>
      {!minDate && (
        <TimeFilter
          onFilterChange={onFilterChange}
          activeFilter={activeFilter}
        />
      )}
      <DateInputsAndDays>
        <DateInputs>
          <InputWrapper size={size}>
            <InputMask
              component={Input}
              mask="__/__/____"
              replacement={DATE_MASK_REPLACEMENT}
              showMask
              value={startInputValue || ''}
              onChange={onInputChange}
              type="text"
              placeholder={t('dateInput.startDate')}
              id="startInputDate"
            />
          </InputWrapper>
          <InputWrapper size={size}>
            <InputMask
              component={Input}
              mask="__/__/____"
              replacement={DATE_MASK_REPLACEMENT}
              showMask
              value={endInputValue}
              onChange={onInputChange}
              type="text"
              placeholder={t('dateInput.endDate')}
              id="endInputDate"
            />
          </InputWrapper>
        </DateInputs>
        <Days />
      </DateInputsAndDays>
      <DatePickerWrapper size={size} toggleCalendar={toggleCalendar}>
        <DatePicker
          size={size}
          onChange={onDateChange}
          value={dates}
          minDate={minDate}
          maxDate={maxDate}
        />
      </DatePickerWrapper>
    </Wrapper>
  );
};

export default DateInput;
